<template>
<div class="application-job">
  <user-ref-row-card :user="applicant" :referrer="referrer" class="user-card" @click="click" />
  <div class="application-action">
    <button class="button is-fullwidth is-inverted"
      :class="[buttonClass, {'is-loading': loading }]"
      @click.prevent="changeState" v-if="buttonState">
      {{ buttonState }}
    </button>
    <div v-if="!buttonState" class="application-status">{{application.status}}</div>
  </div>
</div>
</template>

<script>
import { mapActions } from 'vuex'
import UserRefRowCard from './user-ref-row-card'
// import UserHelper from '@/helpers/user'

export default {
  components: { UserRefRowCard },
  props: {
    application: {
      type: Object,
      default: () => ({})
    }

  },
  computed: {
    applicant () {
      const application = this.application
      return {
        id: application.userId,
        firstName: application.applicantFirstName,
        lastName: application.applicantLastName,
        profilePictureUrl: application.applicantProfilePictureUrl,
        location: application.applicantLocation,
        role: application.applicantRole,
        companyName: application.applicantCompanyName
      }
    },
    buttonState () {
      switch (this.application.status) {
        case 'pending': return 'INTERVIEW'
        case 'interviewing': return 'MAKE OFFER'
      }
      return ''
    },
    buttonClass () {
      switch (this.application.status) {
        case 'pending': return 'is-primary'
        case 'interviewing': return 'is-primary'
      }
      return ''
    }
  },
  data () {
    return {
      loading: false,
      referrer: null
    }
  },
  methods: {
    ...mapActions('adminApplications', {
      updateApplicationState: 'updateState',
      getApplicationsForJob: 'getApplicationsForJob'
    }),
    ...mapActions('jobs', [
      'getApplication'
    ]),
    click (event) {
      this.$emit('click', event)
    },
    async changeState (event) {
      this.loading = true
      try {
        switch (this.application.status) {
          case 'pending': {
            this.click()
            break
          }
          case 'interviewing': {
            this.$emit('makeOffer')
            break
          }
        }
      } catch (error) {}

      this.loading = false
    },
    async getReferrer () {
      const referrerId = this.application.referrerId
      if (referrerId) {
        return {
          id: referrerId,
          firstName: this.application.referrerFirstName,
          lastName: this.application.referrerLastName,
          profilePictureUrl: this.application.referrerProfilePictureUrl
        }
      }
      return null
    }
  },
  async mounted () {
    this.referrer = await this.getReferrer()
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.application-job {
  background-color: white;
  display: flex;
  border: 1px solid $border-color;
  border-bottom: 0px;
}

.user-card:hover {
  background-color: $hover-background;
  cursor: pointer;
}

.application-job:first-child {
  border-top-left-radius: $border-radius;
  border-top-right-radius: $border-radius;
}

.application-job:last-child {
  border-bottom-left-radius: $border-radius;
  border-bottom-right-radius: $border-radius;
  border-bottom: 1px solid $border-color;
}

.application-action {
  width: 191px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
}

.button.is-inverted.is-info {
  border-color: #209cee;
}

.button.is-inverted.is-primary {
  border-color: $primary;
}

.button.is-inverted.is-loading::after {
  border-color: #ddd #ddd #fff #fff !important;
}
.button.is-inverted.is-primary.is-loading::after {
  border-color: $primary $primary #fff #fff !important;
}
.button.is-inverted.is-info.is-loading::after {
  border-color: $info $info #fff #fff !important;
}

.application-status {
  font-size: 14px;
  text-transform: uppercase;
  color: #808080ab;
  font-weight: 600;
  letter-spacing: 2px;
}
@media screen and (max-width: $tablet) {
  .application-job {
    display: block;
    margin-bottom: 1rem;
    border-bottom: 1px solid #ddd !important;
  }
  .user-card {
    width: 100%;
    border-right-width: 0px;
    padding: 0.5rem;
  }
  .application-action {
    border-top: 1px solid #ddd;
    display: block;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    text-align: center;
    padding: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/applications/application-row-card.vue